import { render, staticRenderFns } from "./whatsapps.vue?vue&type=template&id=0c770ab6&scoped=true&"
import script from "./whatsapps.vue?vue&type=script&lang=js&"
export * from "./whatsapps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c770ab6",
  null
  
)

export default component.exports